import React from "react";
import { IoLanguageSharp } from "react-icons/io5";

const LangIcon = ({ onClick, lang }) => {
  return (
    <div className="flex cursor-pointer div-lang" onClick={onClick}>
      <IoLanguageSharp size="24" className="top-navigation-icon" />
      <span className="lang-text hidden md:block">{lang === "en" ? "English" : "Français"}</span>
    </div>
  );
};

export default LangIcon;
